/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 15:21:20
 * @LastEditTime: 2021-01-20 14:22:38
 * @LastEditors: daikeyi
 */
const isProd = process.env.NODE_ENV === 'production';
// sass operation-saas gzrq operation-mobile
const PrefixName = isProd ? 'operation-saas' : 'operation-local';
// const PrefixName = isProd ? 'operation-mobile' : 'operation-local';

// let NotGetPrefixName = true;

// 全域名
// let ServerFullName = isProd ? 'gzgas-osm.gzyouxian.com' : '';

// 拼接域名
const ServerPrefixName = isProd ? '' : 'patrol-mobile';

const DeleteImageApi = '/safecheck/front/delPhoto';

const WxConfigApi = '/wechat/queryWechatConfig';

const WxAuthenticateApi = ['/oauth/oauth2Token', '/oauth/analysisActualOAuthUrl'];

const UploadImageApi = '/wechat/upload';

const UploadCacheImageApi = '/safecheck/front/uploadCachePhoto';

const UploadAppImageApi = '';

const DevelopURL = 'http://safecheck-server-qa.eslink.net.cn';

const UrlConfigDictory = {};

const noticesOption = {
    singleHeight: 50,
    waitTime: 1000,
    limitMoveNum: 1
};

const tabUrl = {
    '0': 'OPHomenew',
    '1': 'OPGoodlist',
    '2': 'OPDotManage', // 网点
    '3': 'OPShoppingcart',
    // '2': 'COStatistics',
    // '4': 'COMe',
    '4': 'OPMembercenter'
};

export default {
    PrefixName,
    // NotGetPrefixName,
    ServerPrefixName,
    WxConfigApi,
    WxAuthenticateApi,
    DeleteImageApi,
    UploadImageApi,
    UploadCacheImageApi,
    UploadAppImageApi,
    DevelopURL,
    UrlConfigDictory,
    noticesOption,
    tabUrl
};
